import { Entries, Lookup } from '../../../common/types/api/LiveLookupResponse'
import type { OptionType } from '../../../common/types/utilities'
import { ActionMeta, OptionTypeBase } from 'react-select'
import { LookupListDataModel } from '../../../common/types/utilities'

export function callbackLookup(lookpus: Lookup[]): OptionType[] {
    return lookpus.filter(({ active }) => active).map(lookup => ({ value: lookup.id, label: lookup.name }))
}

export function callbackLookupValues(entries: Entries[]): OptionType[] {
    return entries
        ?.map(({ key }) => ({ value: key, label: key }))
        .reduce((result: OptionType[], curr) => {
            if (!result.some(elem => elem.value === curr.value)) {
                result.push(curr)
            }

            return result
        }, [])
}

export function onLookupSelected(option: OptionType, actionMeta: ActionMeta<OptionTypeBase>): string {
    if (actionMeta.action === 'select-option') {
        return option.value as string
    }
}

export function onLookupValueSelected(options: OptionType[], actionMeta: ActionMeta<OptionTypeBase>): string[] {
    if (
        actionMeta.action === 'remove-value' ||
        actionMeta.action === 'create-option' ||
        actionMeta.action === 'select-option'
    ) {
        return options.map(({ value }) => value) as string[]
    }

    return []
}

export const getLookupData = (lookupData: LookupListDataModel): LookupListDataModel => {
    if (!lookupData || Object.keys(lookupData).length === 0) {
        return { '': [] } // estado inicial
    }

    return lookupData
}

export const removeLookupData = (lookupName: string, newLookupData: LookupListDataModel): LookupListDataModel => {
    return Object.entries(newLookupData).reduce((result, [keyLookupData, valueLookupData]) => {
        if (keyLookupData === lookupName) return result

        return {
            ...result,
            [keyLookupData]: valueLookupData
        }
    }, {} as LookupListDataModel)
}

export function getCurrentValue(value: OptionType | OptionType[], options:OptionType[], isMulti: boolean, selectValueById?:boolean): OptionType | OptionType[]{
    if(!options || options.length == 0){
        return value
    }

    const valueIsArray = Array.isArray(value)

    if(!selectValueById && isMulti){                
        if(valueIsArray){
            return value
        }else{
            return [value]
        }
    }

    if(!selectValueById && !isMulti){                
        if(valueIsArray){
            return value[0]
        }else{
            return value
        }
    }
    if(selectValueById && isMulti){                
        if(valueIsArray){
            const keys = value.map(valueSelected => valueSelected?.value)
            return options.filter((option) => keys.includes(option?.value))
        }else{            
            return options.filter((option) => option?.value == value?.value)
        }
    }

    if(selectValueById && !isMulti){                
        if(valueIsArray){
            const currentValue =  value[0] || { value:null}
            return options.find((option) => option?.value == currentValue?.value)
        }else{
            return options.find((option) => option?.value == value?.value)
        }
    }
}